import styled, { css } from 'styled-components'

import { FileUploadLeftStyledProps } from './interface'

const styleHoverAndActiveDrag = css`
  background-color: ${({ theme }) => theme.colors.graysGray3};
  color: ${({ theme }) => theme.colors.graysOffBlack};
`

export const FileUpload = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  width: 100%;
  padding: 0 24px;
  font-size: 1.6rem;
  line-height: 2.4rem;
  border-radius: 16px;
  transition: background-color 0.2s, color 0.2s;
  box-sizing: border-box;
  position: relative;
  border-width: 1px;
  border-color: ${({ theme }) => theme.colors.graysGray3};

  margin-top: 15px;

  background-color: ${({ theme }) => theme.colors.graysWhite};
  border-style: solid;

  &:hover,
  &:focus {
    ${styleHoverAndActiveDrag}
  }
`

export const FileUploadLeft = styled.div<FileUploadLeftStyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ uploaded }) => (uploaded ? 'width: 90%;' : 'width: 100%;')}
`
